module.exports = __webpack_public_path__ + "static/Brazil-783403f3dbfa8383003e8f4dcb92aa5a.jpg";